import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelRadio as _vModelRadio, createBlock as _createBlock, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "border border-inputBorder rounded rounded-lg w-293 overflow-hidden absolute z-50 bg-white" }
const _hoisted_2 = { class: "flex items-center justify-between px-3.5 py-3 border-b" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm leading-4 text-placeholder" }, "Filter", -1)
const _hoisted_4 = { class: "cursor-pointer" }
const _hoisted_5 = { class: "z-50 bg-white" }
const _hoisted_6 = { action: "" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  key: 0,
  class: "checkbox-container"
}
const _hoisted_10 = ["onUpdate:modelValue", "value"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1)
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "radio-container" }
const _hoisted_15 = ["onUpdate:modelValue", "value", "id"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "radio" }, null, -1)
const _hoisted_17 = {
  key: 2,
  class: "relative h-42 w-full"
}
const _hoisted_18 = ["onInput", "value"]
const _hoisted_19 = { class: "floating-label" }
const _hoisted_20 = {
  key: 3,
  class: "relative h-42 w-full z-10"
}
const _hoisted_21 = { key: 0 }
const _hoisted_22 = {
  key: 4,
  class: "relative h-42 w-full z-10"
}
const _hoisted_23 = { class: "flex justify-end pt-2.5" }
const _hoisted_24 = {
  key: 5,
  class: "relative h-42 w-full"
}
const _hoisted_25 = ["onInput", "value"]
const _hoisted_26 = { class: "floating-label" }
const _hoisted_27 = {
  key: 6,
  class: "flex items-center justify-start w-full"
}
const _hoisted_28 = {
  key: 7,
  class: "relative h-42 w-full"
}
const _hoisted_29 = {
  key: 8,
  class: "relative h-42 w-full"
}
const _hoisted_30 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseIcon = _resolveComponent("BaseIcon")!
  const _component_FilterPanelGhost = _resolveComponent("FilterPanelGhost")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Datepicker = _resolveComponent("Datepicker")!
  const _component_MixMaxRange = _resolveComponent("MixMaxRange")!
  const _component_GreaterLessThenCondition = _resolveComponent("GreaterLessThenCondition")!
  const _component_vue_collapsible_panel = _resolveComponent("vue-collapsible-panel")!
  const _component_vue_collapsible_panel_group = _resolveComponent("vue-collapsible-panel-group")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("span", _hoisted_4, [
        _createVNode(_component_BaseIcon, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close'))),
          name: "close"
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("form", _hoisted_6, [
        _createVNode(_component_vue_collapsible_panel_group, null, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filters, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.name + item.type,
                class: "overflow-y-auto max-h-550"
              }, [
                _createVNode(_component_vue_collapsible_panel, {
                  expanded: false,
                  onClick: ($event: any) => (_ctx.onExpand(item))
                }, {
                  title: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.name), 1)
                  ]),
                  content: _withCtx(() => [
                    _createElementVNode("div", null, [
                      (item.type === 'checkbox')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                            (item.fetchDataOnExpand && item.dataLoading)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                  _createVNode(_component_FilterPanelGhost)
                                ]))
                              : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(item.data, (check, index) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: check.id
                                  }, [
                                    (_ctx.form && _ctx.form[item.model] && _ctx.form[item.model][index])
                                      ? (_openBlock(), _createElementBlock("label", _hoisted_9, [
                                          _createTextVNode(_toDisplayString(check.value) + " ", 1),
                                          _withDirectives(_createElementVNode("input", {
                                            "onUpdate:modelValue": ($event: any) => ((_ctx.form[item.model][index].checked) = $event),
                                            value: check.id,
                                            ref_for: true,
                                            ref: 'driver'+check.id,
                                            type: "checkbox"
                                          }, null, 8, _hoisted_10), [
                                            [_vModelCheckbox, _ctx.form[item.model][index].checked]
                                          ]),
                                          _hoisted_11
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]))
                                }), 128))
                          ]))
                        : _createCommentVNode("", true),
                      (item.type === 'radio')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                            (item.fetchDataOnExpand && item.dataLoading)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                  _createVNode(_component_FilterPanelGhost)
                                ]))
                              : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(item.data, (radio) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: radio.id
                                  }, [
                                    _createElementVNode("label", _hoisted_14, [
                                      _createTextVNode(_toDisplayString(radio.label) + " ", 1),
                                      _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": ($event: any) => ((_ctx.form[item.model]) = $event),
                                        value: radio.id,
                                        id: radio.id,
                                        type: "radio"
                                      }, null, 8, _hoisted_15), [
                                        [_vModelRadio, _ctx.form[item.model]]
                                      ]),
                                      _hoisted_16
                                    ])
                                  ]))
                                }), 128))
                          ]))
                        : _createCommentVNode("", true),
                      (item.type === 'text')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                            _createElementVNode("input", {
                              onInput: ($event: any) => (_ctx.onFilterTextChange($event.target.value, item)),
                              value: _ctx.form[item.model],
                              type: "text",
                              class: "form-control h-42",
                              placeholder: " "
                            }, null, 40, _hoisted_18),
                            _createElementVNode("label", _hoisted_19, _toDisplayString(item.label), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (item.type === 'select')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                            (item.fetchDataOnExpand && item.dataLoading)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                  _createVNode(_component_FilterPanelGhost)
                                ]))
                              : (_openBlock(), _createBlock(_component_Multiselect, {
                                  key: 1,
                                  canClear: false,
                                  modelValue: _ctx.form[item.model],
                                  "onUpdate:modelValue": ($event: any) => ((_ctx.form[item.model]) = $event),
                                  options: item.data,
                                  label: "value",
                                  valueProp: "id",
                                  object: "true",
                                  noOptionsText: _ctx.$t('validation.noItemsToShow')
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "noOptionsText"]))
                          ]))
                        : _createCommentVNode("", true),
                      (item.type === 'order')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                            _createVNode(_component_Multiselect, {
                              class: "fixed-multiselect",
                              canClear: false,
                              modelValue: _ctx.form.orderBy,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.orderBy) = $event)),
                              options: item.data,
                              label: "value",
                              valueProp: "id",
                              object: "true",
                              noOptionsText: _ctx.$t('validation.noItemsToShow')
                            }, null, 8, ["modelValue", "options", "noOptionsText"]),
                            _createElementVNode("div", _hoisted_23, [
                              (_ctx.form.sort === 'asc')
                                ? (_openBlock(), _createBlock(_component_BaseIcon, {
                                    key: 0,
                                    class: "cursor-pointer",
                                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.sort = 'desc')),
                                    style: {"width":"18px"},
                                    name: "arrow"
                                  }))
                                : _createCommentVNode("", true),
                              (_ctx.form.sort === 'desc')
                                ? (_openBlock(), _createBlock(_component_BaseIcon, {
                                    key: 1,
                                    class: "cursor-pointer",
                                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.form.sort = 'asc')),
                                    style: {"width":"18px","transform":"rotate(180deg)"},
                                    name: "arrow"
                                  }))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (item.type === 'number')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                            _createElementVNode("input", {
                              onInput: ($event: any) => (_ctx.onFilterTextChange($event.target.value, item)),
                              value: _ctx.form[item.model],
                              type: "number",
                              class: "form-control h-42",
                              placeholder: " "
                            }, null, 40, _hoisted_25),
                            _createElementVNode("label", _hoisted_26, _toDisplayString(item.label), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (item.type === 'date')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                            (item.calendarType === 'time')
                              ? (_openBlock(), _createBlock(_component_Datepicker, {
                                  key: 0,
                                  timePicker: "",
                                  modelValue: _ctx.form[item.model],
                                  "onUpdate:modelValue": ($event: any) => ((_ctx.form[item.model]) = $event),
                                  class: "w-full"
                                }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                              : _createCommentVNode("", true),
                            (item.calendarType === 'month')
                              ? (_openBlock(), _createBlock(_component_Datepicker, {
                                  key: 1,
                                  onCleared: ($event: any) => (_ctx.clearMonth(item.model)),
                                  monthPicker: "",
                                  modelValue: _ctx.form[item.model],
                                  "onUpdate:modelValue": ($event: any) => ((_ctx.form[item.model]) = $event),
                                  class: "w-full"
                                }, null, 8, ["onCleared", "modelValue", "onUpdate:modelValue"]))
                              : _createCommentVNode("", true),
                            (item.calendarType === 'datepicker')
                              ? (_openBlock(), _createBlock(_component_Datepicker, {
                                  key: 2,
                                  modelValue: _ctx.form[item.model],
                                  "onUpdate:modelValue": ($event: any) => ((_ctx.form[item.model]) = $event),
                                  format: 'dd.MM.yyyy',
                                  previewFormat: 'dd.MM.yyyy',
                                  class: "w-full"
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "format", "previewFormat"]))
                              : _createCommentVNode("", true),
                            (item.calendarType === 'range')
                              ? (_openBlock(), _createBlock(_component_Datepicker, {
                                  key: 3,
                                  onCleared: ($event: any) => (_ctx.form[item.model] = ['', '']),
                                  modelValue: _ctx.form[item.model],
                                  "onUpdate:modelValue": ($event: any) => ((_ctx.form[item.model]) = $event),
                                  format: 'dd.MM.yyyy HH:mm',
                                  previewFormat: 'dd.MM.yyyy HH:mm - dd.MM.yyyy HH:mm',
                                  range: "",
                                  multiCalendars: "",
                                  class: "w-full"
                                }, null, 8, ["onCleared", "modelValue", "onUpdate:modelValue", "format", "previewFormat"]))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true),
                      (item.type === 'min-max-range')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                            _createVNode(_component_MixMaxRange, {
                              "model-value": _ctx.form[item.model],
                              "onUpdate:modelValue": (e) => _ctx.form[item.model] = e
                            }, null, 8, ["model-value", "onUpdate:modelValue"])
                          ]))
                        : _createCommentVNode("", true),
                      (item.type === 'condition')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                            _createVNode(_component_GreaterLessThenCondition, {
                              "model-value": _ctx.form[item.model],
                              "onUpdate:modelValue": (e) => _ctx.form[item.model] = e
                            }, null, 8, ["model-value", "onUpdate:modelValue"])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]))
            }), 128)),
            _createElementVNode("div", {
              class: _normalizeClass(["w-full flex items-center justify-center", _ctx.formHasValue ? 'bg-lightRed' : 'bg-hintColor'])
            }, [
              _createElementVNode("button", {
                disabled: !_ctx.formHasValue,
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.resetForm())),
                type: "button",
                class: "py-3 w-full text-sm leading-4 text-center text-white"
              }, "Restore to defaults", 8, _hoisted_30)
            ], 2)
          ]),
          _: 1
        })
      ])
    ])
  ]))
}